import Modal from "../../../components/Modal";
import ModalWrapper from "../../../components/ModalWrapper";
import { Trans } from "@lingui/macro";
import { AutoColumn } from "../../../components/Column";
import { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import NumericalInput from "../../../components/NumericalInput";
import TextInput from "../../../components/TextInput";
import MultiSelect from "../../../components/MultiSelect";
import { SoftTypeA } from "../../../constants/dict";
//import { MINI_POOL_ADDRESS } from "../../../constants/address";

import { ButtonPrimary } from "../../../components/Button";
import Loader from "../../../components/Loader";
const InputNumerical = styled(NumericalInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const InputText = styled(TextInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const LabelWrapper = styled.div`
  font-size: 14px;
`;

const Symbol = styled.div`
  margin-left: 8px;
`;

const BalanceWrapper = styled.div`
  font-size: 14px;
`;

function UpdateAppVersionModal({
  isOpen,
  setIsOpen,
  minPledge,
  appgroupOpt,
  token,
  pkgitem,
}) {


  const [loading, setLoading] = useState(false);
  const [appid, setAppid] = useState();

  const [versionid, setVersionid] = useState('');
  const [version, setVersion] = useState(0);
  const [merchantid, setMerchantid] = useState(0);
  const [softtype, setSofttype] = useState(1);
  const [updatetag, setUpdatetag] = useState("");
  const [docsurl, setDocsurl] = useState("");
  const [ext, setExt] = useState("");


 useEffect(() => {
  if (pkgitem ) {
    setAppid(pkgitem.appid);
    setVersionid(pkgitem.versionid);
    setVersion(pkgitem.version);
    setMerchantid(pkgitem.merchantid);
    setSofttype(pkgitem.softtype);
    setUpdatetag(pkgitem.updatetag);
    setDocsurl(pkgitem.docsurl);
    setExt(pkgitem.ext);
  } else {
    setAppid("");
    setVersionid(0);
    setVersion("");
    setMerchantid("");
    setSofttype(1);
    setUpdatetag("");
    setDocsurl("");
    setExt("");
  }

}, [pkgitem]);



  const handleOnPledge = useCallback(async () => {
    //console.log("getToken",await appgroupOpt.getToken());
    // getNodeInfo
    const tx = await appgroupOpt.updateAppVersion(
      versionid,
      appid,
      version,
      softtype,
      updatetag,
      docsurl,
      ext,
      setLoading,
     
    );
    console.log(tx);
  }, [appid, docsurl, ext, appgroupOpt, softtype, updatetag, version, versionid]);




  return (
    <Modal isOpen={isOpen} onDismiss={() => setIsOpen(false)}>
      {token ? (
        <ModalWrapper
          title={<Trans>Publish Update version</Trans>}
          toggleWalletModal={() => setIsOpen(false)}
        >
          <AutoColumn gap={"24px"}>
            <AutoColumn gap={"sm"}>
              {/* <LabelWrapper>
                <Trans>appid</Trans>
              </LabelWrapper>
                <InputText value={ appid }
                           onUserInput={ setAppid } />

              <LabelWrapper>
                <Trans>versionid</Trans>
              </LabelWrapper>
              <InputText value={versionid} onUserInput={setVersionid} />
            */}
              <LabelWrapper>
                <Trans>version</Trans>
              </LabelWrapper>
              <InputText value={version} onUserInput={setVersion} />

              <LabelWrapper>
                <Trans>softtype</Trans>
              </LabelWrapper>
              <MultiSelect List={SoftTypeA} selectValue={softtype} onUserInput={setSofttype} />

              <LabelWrapper>
                <Trans>updatetag</Trans>
              </LabelWrapper>
              <InputText value={updatetag} onUserInput={setUpdatetag} />
           

            <LabelWrapper>
                <Trans>docsurl</Trans>
              </LabelWrapper>
              <InputText value={docsurl} onUserInput={setDocsurl} />
            

  
               {/* <LabelWrapper>
                <Trans>ext</Trans>
              </LabelWrapper>
              <InputText value={ext} onUserInput={setExt} /> */}

              </AutoColumn>
 
              <ButtonPrimary
                onClick={handleOnPledge}
                disabled={loading}
              >
                {loading && <Loader />} <Trans>Update Version</Trans>
              </ButtonPrimary>
           
          </AutoColumn>
        </ModalWrapper>
      ) : null}
    </Modal>
  );
}

export default UpdateAppVersionModal;
